import { register } from "@rill/loader";

register(
  {
    name: "mealPlanCountDetailed",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;
    const query = { coachId: _id, planMode: "detailed" };
    const res = await api(`meal-plan-template-count`, { query });
    const data = await res.json();
    const { mealPlanCount = 0 } = data;
    return mealPlanCount;
  }
);

register(
  {
    name: "mealPlanCountSimplified",
    meta: ["no-bust", "meal-plan"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    const { activeUserToRequest } = locals;
    const { _id } = activeUserToRequest;
    const query = { coachId: _id, planMode: "simplified" };
    const res = await api(`meal-plan-template-count`, { query });
    const data = await res.json();
    const { mealPlanCount = 0 } = data;
    return mealPlanCount;
  }
);
